import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {finalize, Observable, Subscription} from 'rxjs';
import {SitePublicService} from 'src/app/services/site-public.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {AngularFireUploadTask} from '@angular/fire/compat/storage';
import {FileManagerService} from 'src/app/shared/file-manager/file-manager.service';
import {YoutubeDialogComponent} from '../../dialogs/youtube-dialog/youtube-dialog.component';

@Component({
  selector: 'app-youtube',
  templateUrl: './youtube.component.html',
  styleUrls: [ './youtube.component.scss' ]
})
export class YoutubeComponent implements OnInit, OnDestroy {

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'image', 'title', 'edit', 'delete' ];

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  private subscription: Subscription | undefined;
  // Variáveis para upload
  //selectedFile: File | null = null;
  selectedFileName?: any | null = null;
  storedImage: any | null = null;

  uploadTask: AngularFireUploadTask | undefined;
  uploadProgress: Observable<number | undefined> | undefined;
  downloadURL: string | null = null;
  isUploading = false;
  uploadError: string | null = null;

  constructor (
    private _sitePublicService: SitePublicService,
    private _dialog: MatDialog,
    private _spinnerService: SpinnerService,
    private _snackBar: SnackBarIconService,
    private _fileManagerService: FileManagerService) {

    /*
    if (!this._authService.isAdmin) {
    this.router.navigate([ 'home' ]);
    }
    */

    this.loadData()
  }

  ngOnInit () { }

  ngOnDestroy () {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  loadData () {

    const waiting = this._spinnerService.show();

    // 1. Chama o serviço que retorna o Observable
    const statute$ = this._sitePublicService.loadYoutube();

    // 2. Se inscreve no Observable
    this.subscription = statute$.subscribe({
      next: (array: any[]) => {
        // Este código será executado na primeira vez E em cada mudança subsequente.
        this.dataSource = new MatTableDataSource(array);
        this.dataSource.sort = this.sort;
        // O 'waiting.close()' deve ser feito apenas na primeira vez.
        // Uma forma simples é verificar se o spinner está aberto ou usar 'finalize' no pipe.
        // Aqui, vamos apenas fechar, assumindo que já está aberto.
        if (waiting) {
          waiting.close();
        }
      },
      error: (error) => {
        console.error('Erro ao carregar dados: ', error);
        if (waiting) {
          waiting.close();
        }
        // Trate o erro (ex: exibir mensagem para o usuário)
      },
      // O complete não é chamado, pois é um Observable "infinito" (tempo real)
    });
  }

  openDialog (entity: any) {

    let data: any = {};
    if (entity) {
      data = entity;
    } else {
      data = {'id': "0", 'src': '', 'file': '', 'alt': '', 'link': '', 'dateIn': null, 'dateOut': null};
    }

    let dialogRef = this._dialog.open(YoutubeDialogComponent, {
      // width: window.innerWidth.toString() + "px",
      width: "900px",
      height: window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: any = response[ 1 ];
        const selectedFile: any = response[ 2 ];
        const formData = form.getRawValue();

        // console.log("actionType: " + actionType);
        // console.log("selectedFile: " + selectedFile);
        // console.log("formData: " + JSON.stringify(formData));

        if (actionType == 'insert') {

          delete formData.id;

          await this._sitePublicService.insertYoutube(formData)
            .then(async (result) => {
              if (selectedFile) {
                this.startUpload(result.id, selectedFile);
              } else {
                this._snackBar.openSnackBar("Sucesso!", '', 'success')
              }
            })
            .catch((err: any) => {
              console.log("erro ao adicionar Youtube")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });
        } else {
          const id = formData.id;
          const data = formData

          await this._sitePublicService.updateYoutube(id, data)
            .then(async () => {
              if (selectedFile) {
                this._sitePublicService.deleteFileInStorage(data.src)
                this.startUpload(data.id, selectedFile);
              } else {
                this._snackBar.openSnackBar("Sucesso!", '', 'success')
              }
            })
            .catch((err: any) => {
              console.log("erro ao atualizar Youtube")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });

        }
      })

  }

  delete (element) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.file + "<br><br>Excluir este vídeo?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        const id = element.id;
        const src = element.src;

        this._sitePublicService.deleteFileInStorage(src)

        this._sitePublicService.deleteYoutube(id)
          .then(
            () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete Youtube error: " + error.message)}
          )
      }
    })
  }

  startUpload (id: string, selectedFile: any): void {

    const waiting = this._spinnerService.show();

    this._fileManagerService.storage_path = "site_pub/youtube/" + id;

    this.isUploading = true;
    this.uploadError = null;
    this.downloadURL = null;

    const {task, downloadURL$} = this._fileManagerService.uploadFile(selectedFile);
    this.uploadTask = task;

    // Acompanhar o progresso
    this.uploadProgress = this.uploadTask.percentageChanges();

    // Obter o URL de download e finalizar
    downloadURL$.pipe(
      finalize(() => {
        this.isUploading = false;
        this.uploadTask = undefined;
      })
    ).subscribe({
      next: (url) => {
        if (url) {
          this.downloadURL = url;
          this._sitePublicService.updateYoutube(id, {src: url})
            .then(() => {
              console.log("upload image Youtube success")
            })
            .catch((err) => {
              console.log("erro upload Youtube image")
            })
            .finally(() => {
              waiting.close();
            })

        }
      },
      error: (err) => {
        this.uploadError = 'Erro no upload: ' + (err.message || 'Desconhecido');
        console.error('Erro no upload:', err);
      }
    });
  }

  previewContent (element) {

  }
}
